import * as React from 'react'
import {compose} from 'redux'
import Geosuggest  from 'react-geosuggest'
import {createStyles, Theme, WithStyles, withStyles} from '@material-ui/core'
import autobind from 'autobind-decorator'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import './geosuggest.css'

const styles = (t: Theme) => createStyles({
    addressAutocomplete:{
        position: 'relative',
        fontSize: '16px',
        width: '100%',
        lineHeight: '1.1875em',
        display: 'inline-block',
        height: '100%',
        backgroundColor: 'transparent',
        transition: 'height 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
        cursor: 'auto'
    }, 
    geosuggestLabel: {
        userSelect: 'none',
        position: 'absolute',
        top: '19px',
        left:0,
        transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
        zIndex: 1,
        lineHeight: '22px',
        transformOrigin: 'left top 0px',
        pointerEvents: 'none',
        color: 'rgba(0, 0, 0, 0.298039)',
        transform: 'scale(0.75) translate(0px, -28px)'
    },
    geosugestUnderline: {
        borderTop: 'none rgb(224, 224, 224)',
        borderRight: 'none rgb(224, 224, 224)',
        borderBottom: '1px solid rgb(224, 224, 224)',
        borderLeft: 'none rgb(224, 224, 224)',
        borderImage: 'initial',
        bottom: 0,
        boxSizing: 'content-box',
        margin: 0,
        position: 'absolute',
        width: '100%'
      }
})

interface IProps extends WithI18n,
  WithStyles<typeof styles> {
  dispatch: any;
  label?: string;
  value?: string;
  placeholder?: string;
  onPlaceChanged: (place: object) => void;
}

class GeosuggestInput extends React.Component<IProps, {}> {
    render(){
        const { label, value, placeholder, classes } = this.props;
        return(
            <div className={classes.addressAutocomplete}>
                <label className={classes.geosuggestLabel}>{label}</label>
                <Geosuggest
                    onSuggestSelect={this.splitAddress}
                    initialValue={value}
                    placeholder={placeholder}
                />
                <div>
                    <hr className={classes.geosugestUnderline} />
                </div>
            </div>
        )
    }

    @autobind
    private splitAddress(suggest){
        if(suggest){
            const { onPlaceChanged } = this.props;
            // Here we define the fields we want to get from the google's place object
            const componentForm = {
                street_number: "short_name",
                route: "long_name",
                locality: "long_name",
                country: "short_name",
                postal_code: "short_name",
                colloquial_area: "long_name"
            };

            const place = suggest.gmaps;

            const addressSplitted = {};

            // Now we fill our addressSplitted object with the fields setted by the user
            for (const addressItem of place.address_components) {
                const addressType = addressItem.types[0];
                if(componentForm[addressType]){
                    addressSplitted[addressType] = addressItem[componentForm[addressType]];
                }
            }

            /*
            here we can call the user's function and pass the address array as param
            */
            onPlaceChanged(addressSplitted);
        }
    }
}

export default compose(
    withI18n,
    withStyles(styles),
)(GeosuggestInput)


// WEBPACK FOOTER //
// ./src/shared/Autocomplete/GeosuggestInput.tsx